/**
 * @deprecated This file is deprecated. Import from the main flows module instead.
 *
 * This file exists only for backwards compatibility with existing tests.
 * New code should import directly from:
 * - @polyai/stream/store/reducers/flows (for reducer, selectors, actions)
 * - @polyai/stream/store/reducers/flows/adapters (for adapters)
 */

// Re-export selectors
export {
  flowStepsSelectors as stepsSelectors,
  flowsSelectors,
  selectAdvancedStepById,
  selectAdvancedSteps,
  selectDefaultStepById,
  selectDefaultSteps,
  transitionFunctionsSelectors as flowFunctionsSelectors,
} from '@polyai/stream/store/reducers/flows';
// Re-export adapters
export {
  advancedStepRefAdapter,
  /**
   * @deprecated This adapter is deprecated. Use advancedStepRefAdapter instead.
   */
  advancedStepRefAdapter as stepReferencesAdapter,
  defaultStepRefAdapter as noCodeStepReferencesAdapter,
  flowStepsAdapter as noCodeStepsAdapter,
  flowsAdapter,
  transitionFunctionRefAdapter,
  transitionFunctionsAdapter as functionsAdapter,
} from '@polyai/stream/store/reducers/flows/adapters';
// Re-export types for backwards compatibility
export type {
  AdvancedStep as FlowStep,
  Condition,
  DefaultStep as NoCodeStep,
  Flow,
  FlowFunction,
  Step,
  StepAsrBiasing,
  StepDTMFConfig,
} from '@polyai/stream/store/reducers/flows/types';

// Legacy helper exports
import type {
  StepAsrBiasing,
  StepDTMFConfig,
} from '@polyai/stream/store/reducers/flows/types';

export const getDefaultAsrBiasing = (): StepAsrBiasing => ({
  alphanumeric: false,
  nameSpelling: false,
  numeric: false,
  partySize: false,
  preciseDate: false,
  relativeDate: false,
  singleNumber: false,
  time: false,
  yesNo: false,
  address: false,
  customKeywords: [],
  isEnabled: false,
});

export const getDefaultDTMFConfig = (): StepDTMFConfig => ({
  isEnabled: false,
  interDigitTimeout: 0,
  maxDigits: 0,
  endKey: '#',
  collectWhileAgentSpeaking: false,
  isPii: false,
});
